/**
 * Takes in base64 SVG string,
 * replaces color with given parameters and returns back the base64 encoded string.
 *
 * @param svgString Original svg base 64 string.
 * @param oldColor Color to replace.
 * @param newColor Color to replace to.
 */
export const themeSVGBase64 = (svgString: string, oldColor: string, newColor: string): string => {
  // 1. Split given base64 string.
  // First part will be 'data:image/svg+xml;base64'
  // Second part will be base64 encrypted svg string
  const svgSplit = svgString.split(',');

  // Should not hit this!
  // But if split string's first part doesn't match 'data:image/svg+xml;base64' format or
  // second part(svg string) doesn't exist, return the original svg.
  if (svgSplit[0] !== 'data:image/svg+xml;base64' || !svgSplit[1]) {
    return svgString;
  }

  // 2. Convert to raw svg mark-up, eg; <svg> .... </svg>
  const svgRawMarkup = Buffer.from(svgSplit[1], 'base64').toString('binary');

  // 3. Replace color.
  const svgReplacedColor = svgRawMarkup.replace(oldColor, newColor);

  // 4. Convert back to base64
  const newSvgToBase64 = Buffer.from(svgReplacedColor).toString('base64');
  const finalImageString = `data:image/svg+xml;base64,${newSvgToBase64}`;
  return finalImageString;
};
